import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=4e5ff37b&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=4e5ff37b&prod&lang=scss&scoped=true"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=4e5ff37b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ff37b",
  null
  
)

export default component.exports